import React from 'react';

interface IProps {
  steps: {
    number: number;
    isSelected: boolean;
    title: string;
  }[];
  className?: string;
}

export default function SimpleStepBar({ steps, className }: IProps) {
  return (
    <div className="lg:p-0 p-2 md:bg-transparent bg-[#F4F4F4]">
      <div className={`flex items-center gap-2 ${className}`}>
        {steps.map((stp, index) => {  
          return (
            <div className="flex justify-center items-center gap-2" key={index}>
              <div
                className={`flex px-2 rounded-full ${
                  stp.number === 1
                    ? stp.isSelected
                      ? 'bg-[#1DA707]'
                      : 'bg-[#FBB90F]'
                    : stp.isSelected
                      ? 'bg-[#FBB90F]'
                      : 'bg-reliableBlack70'
                }   w-[30px] h-[30px] text-white justify-center items-center`}
              >
                <p className="lg:text-[18px] text-[14px]">{stp.number}</p>
              </div>
              <p className="lg:text-[20px] text-[14px] text-reliableBlack100">{stp.title}</p>
              {index < steps.length - 1 && <div className="border-b border-b-reliableBlack w-[40px] " />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
